// Sous-traitance CTA — YouTube facade (load iframe on click)
(function () {
  'use strict';

  /* Libelles : snippets/i18n-js.liquid (window.FOG_I18N, charge avant ce script
     par layout/theme.liquid). Lu a l'appel, jamais en dur. Spec 07. */
  function i18n(cle, vars) {
    return window.FOG_I18N.t(cle, vars);
  }

  function activate(facade) {
    if (facade.dataset.activated === 'true') return;
    var id = facade.getAttribute('data-youtube-id');
    if (!id) return;
    var params = facade.getAttribute('data-youtube-params') || 'rel=0&controls=1&autoplay=1&mute=0';
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?' + params;
    iframe.title = i18n('pages.subcontracting.video_player_title');
    iframe.frameBorder = '0';
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    iframe.loading = 'lazy';
    // Replace facade content with iframe
    facade.innerHTML = '';
    facade.appendChild(iframe);
    facade.dataset.activated = 'true';
  }

  function bootstrap() {
    var facades = document.querySelectorAll('.st-cta__video--facade');
    facades.forEach(function (f) {
      if (f.dataset.bound === 'true') return;
      f.dataset.bound = 'true';
      // Preconnect hints for faster first load
      ['https://www.youtube.com', 'https://i.ytimg.com', 'https://s.ytimg.com'].forEach(function (origin) {
        if (document.querySelector('link[rel="preconnect"][href="' + origin + '"]')) return;
        var link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = origin;
        document.head.appendChild(link);
      });
      f.addEventListener('click', function () { activate(f); });
      f.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          activate(f);
        }
      });
      // Make facade keyboard-focusable (button handles most, but also container)
      f.setAttribute('tabindex', '-1');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', bootstrap);
  }
})();
